import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";
import WavyLoader from "components/v2/WavyLoader";

const SubscriptionsPageLoader = () => {
	return (
		<Container className="min-h-screen flex flex-col w-full bg-gradient-to-b from-white via-gray-50 to-white">
			<div className="relative overflow-hidden">
				{/* Decorative background elements */}
				<div className="absolute inset-0 bg-gradient-to-b from-akgreener/5 to-transparent" />
				<div className="absolute top-0 left-0 w-96 h-96 bg-akgreener/10 rounded-full filter blur-3xl -translate-x-1/2 -translate-y-1/2" />
				<div className="absolute top-0 right-0 w-96 h-96 bg-akgreenest/10 rounded-full filter blur-3xl translate-x-1/2 -translate-y-1/2" />

				<div className="relative mt-16 mb-20">
					<PaddingX>
						<div className="max-w-7xl mx-auto">
							{/* Title section loader */}
							<div className="text-center mb-12">
								<WavyLoader width={400} height={32} className="mx-auto mb-4" />
								<WavyLoader width={600} height={24} className="mx-auto" />
							</div>

							{/* Table skeleton */}
							<div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200">
								<div className="overflow-x-auto">
									<table className="w-full">
										<thead>
											<tr>
												{/* Features column header */}
												<th className="w-1/4 px-6 py-4 text-left text-sm font-medium text-gray-500 bg-gray-50">
													<WavyLoader width={80} height={20} />
												</th>
												{/* Subscription plan headers - create 3 skeleton columns */}
												{[1, 2, 3].map((index) => (
													<th
														key={index}
														className={`px-6 py-4 text-center text-sm font-medium text-white relative ${
															index === 1
																? "bg-akgreen"
																: index === 2
																? "bg-akgreener"
																: "bg-akgreenest"
														}`}
													>
														<div className="flex flex-col items-center">
															{/* Category Badge skeleton */}
															<div className="w-16 h-6 bg-white/20 rounded-full mb-2 animate-pulse" />
															{/* Plan name skeleton */}
															<div className="w-20 h-6 bg-white/20 rounded mb-1 animate-pulse" />
															{/* Recommendation text skeleton */}
															{index === 1 && (
																<div className="w-24 h-4 bg-white/20 rounded animate-pulse" />
															)}
														</div>
													</th>
												))}
											</tr>
										</thead>
										<tbody>
											{/* Duration Row */}
											<tr className="bg-white">
												<td className="px-6 py-4 text-sm font-medium text-gray-700">
													<WavyLoader width={60} height={16} />
												</td>
												{[1, 2, 3].map((index) => (
													<td key={index} className="px-6 py-4 text-center text-sm text-gray-600">
														<WavyLoader width={80} height={16} className="mx-auto" />
													</td>
												))}
											</tr>

											{/* Price Row */}
											<tr className="bg-gray-50">
												<td className="px-6 py-4 text-sm font-medium text-gray-700">
													<WavyLoader width={40} height={16} />
												</td>
												{[1, 2, 3].map((index) => (
													<td key={index} className="px-6 py-4 text-center">
														<div className="flex flex-col items-center space-y-1">
															<WavyLoader width={100} height={32} className="mx-auto" />
															<WavyLoader width={80} height={12} className="mx-auto" />
														</div>
													</td>
												))}
											</tr>

											{/* Books Access Row */}
											<tr className="bg-white">
												<td className="px-6 py-4 text-sm font-medium text-gray-700">
													<WavyLoader width={100} height={16} />
												</td>
												{[1, 2, 3].map((index) => (
													<td key={index} className="px-6 py-4 text-center text-sm text-gray-600">
														<WavyLoader width={60} height={16} className="mx-auto" />
													</td>
												))}
											</tr>

											{/* Unlimited Free Titles Row */}
											<tr className="bg-gray-50">
												<td className="px-6 py-4 text-sm font-medium text-gray-700">
													<WavyLoader width={140} height={16} />
												</td>
												{[1, 2, 3].map((index) => (
													<td key={index} className="px-6 py-4 text-center">
														<div className="w-6 h-6 bg-gray-300 rounded animate-pulse mx-auto" />
													</td>
												))}
											</tr>

											{/* Offline Reading Row */}
											<tr className="bg-white">
												<td className="px-6 py-4 text-sm font-medium text-gray-700">
													<WavyLoader width={120} height={16} />
												</td>
												{[1, 2, 3].map((index) => (
													<td key={index} className="px-6 py-4 text-center">
														<div className="w-6 h-6 bg-gray-300 rounded animate-pulse mx-auto" />
													</td>
												))}
											</tr>

											{/* Action Row */}
											<tr className="bg-white">
												<td className="px-6 py-4 text-sm font-medium text-gray-700">
													<WavyLoader width={50} height={16} />
												</td>
												{[1, 2, 3].map((index) => (
													<td key={index} className="px-6 py-4 text-center">
														<WavyLoader width={120} height={36} className="mx-auto rounded-full" />
													</td>
												))}
											</tr>
										</tbody>
									</table>
								</div>
							</div>

							{/* Legend skeleton */}
							<div className="mt-8 flex flex-wrap justify-center gap-6">
								<div className="flex items-center gap-2">
									<div className="w-4 h-4 bg-akgreen rounded animate-pulse" />
									<WavyLoader width={100} height={16} />
								</div>
								<div className="flex items-center gap-2">
									<div className="w-4 h-4 bg-akgreener rounded animate-pulse" />
									<WavyLoader width={120} height={16} />
								</div>
								<div className="flex items-center gap-2">
									<div className="w-4 h-4 bg-akgreenest rounded animate-pulse" />
									<WavyLoader width={100} height={16} />
								</div>
							</div>
						</div>
					</PaddingX>
				</div>
			</div>
		</Container>
	);
};

export default SubscriptionsPageLoader;
